import styles from "../css/SetupTable.module.css";
import formStyles from "../css/SetupForm.module.css";

export default function ItemGroupingTable({
  itemGroupings,
  setItemGroupings,
  onGroupEdit,
}) {
  const handleTitleChange = (index) => (event) => {
    const newItemGroupings = itemGroupings.slice();
    newItemGroupings[index].item_group_title = event.target.value;
    setItemGroupings(newItemGroupings);
  };

  return (
    <table className={styles.table}>
      <thead>
        <tr>
          <th className={styles.description} style={{ width: "32rem" }}>
            Group Title
          </th>
          <th>Items</th>
          <th style={{ width: "8rem" }}>Action</th>
        </tr>
      </thead>

      <tbody>
        {itemGroupings.map((itemGroup, index) => (
          <tr key={index}>
            <td>
              <input
                type="text"
                onChange={handleTitleChange(index)}
                className={formStyles.numberInput}
                style={{ width: "100%" }}
                value={itemGroup.item_group_title}
              />
            </td>
            <td>{itemGroup.items.length}</td>
            <td>
              <button
                type="button"
                className={styles.actionButton}
                onClick={onGroupEdit(index)}
              >
                Edit
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
